"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _styles = require("@mui/styles");
var _ArrowDropDown = _interopRequireDefault(require("@mui/icons-material/ArrowDropDown"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles2 = require("./styles");
var _AnchorLink = _interopRequireDefault(require("../AnchorLink"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StyledMenu = _ref => {
  let {
    classes,
    label,
    list
  } = _ref;
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const handleOpen = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.styledMenu
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.buttonContainer,
    onClick: handleOpen
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: classes.button
  }, label), /*#__PURE__*/_react.default.createElement(_ArrowDropDown.default, null)), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    anchorEl: anchorEl,
    id: "simple-menu",
    open: Boolean(anchorEl),
    onClose: handleClose
  }, list.map(item => /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    key: item.label,
    className: classes.menuItem
  }, /*#__PURE__*/_react.default.createElement(_AnchorLink.default, {
    label: item.label,
    href: item.link,
    newTab: item.newTab
  })))));
};
StyledMenu.propTypes = {
  label: _propTypes.default.string,
  list: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    link: _propTypes.default.string,
    newTab: _propTypes.default.bool
  }))
};
var _default = exports.default = (0, _styles.withStyles)(_styles2.useStyles)(StyledMenu);